import { render, staticRenderFns } from "./MediaFileThumbnail.vue?vue&type=template&id=fd5246ba&"
import script from "./MediaFileThumbnail.vue?vue&type=script&lang=ts&"
export * from "./MediaFileThumbnail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports